import arrayify from './arrayify'

export default function findOneMostRecentActivity (activity, itemId) {
  const activities = arrayify(activity)
  let oneMostRecentActivity
  activities.forEach( (activ) => {
    if (itemId === activ.itemId) {
      if (!oneMostRecentActivity) {
        oneMostRecentActivity = activ
      } else {
        if (oneMostRecentActivity.timestamp < activ.timestamp) {
          oneMostRecentActivity = activ
        }
      }
    }
  })
  return oneMostRecentActivity
}


// WEBPACK FOOTER //
// ./src/helpers/findOneMostRecentActivity.js